import { eventBus } from '@sm/max-common'

const hiddenProperty =
  "hidden" in document
    ? "hidden"
    : "webkitHidden" in document
      ? "webkitHidden"
      : "mozHidden" in document
        ? "mozHidden"
        : null

const visibilityChangeEvent = hiddenProperty.replace(
  /hidden/i,
  "visibilitychange"
)

export function register() {
  const events = eventBus.create()

  /**
  * 监听页面显示/隐藏
  */
  function onPageVisibility(fn: { show?: () => void; hide?: () => void }) {
    const controller = new AbortController()
    const onVisibilityChange = () => {
      if (!(document as any)[hiddenProperty]) {
        fn.show && fn.show()
      } else {
        fn.hide && fn.hide()
      }
    }
    document.addEventListener(visibilityChangeEvent, onVisibilityChange, {
      signal: controller.signal,
    })
    return controller
  }

  let foregroundController: AbortController = null
  let backgroundController: AbortController = null
  let appShowController: AbortController = null
  let appHideController: AbortController = null

  function send<T>(key: string, params: T) {
    events.send(key, params)
  }

  function registerAppEvent(key: string, fn: () => void) {
    switch (key) {
      case "onAppSwitchToForeground":
        if (foregroundController) return
        foregroundController = onPageVisibility({ show: fn })
        break
      case "onAppSwitchToBackground":
        if (backgroundController) return
        backgroundController = onPageVisibility({ hide: fn })
        break
      case "appShow":
        if (appShowController) return
        appShowController = onPageVisibility({ show: fn })
        break
      case "appHide":
        if (appHideController) return
        appHideController = onPageVisibility({ hide: fn })
        break
      default:
        return events.addListener(key, fn)
    }
  }

  function unregisterAppEvent(key: string, fn?: () => void) {
    switch (key) {
      case "onAppSwitchToForeground":
        if (foregroundController?.abort) {
          foregroundController?.abort?.()
          foregroundController = null
        }
        break
      case "onAppSwitchToBackground":
        if (backgroundController?.abort) {
          backgroundController?.abort?.()
          backgroundController = null
        }
        break
      case "appShow":
        if (appShowController?.abort) {
          appShowController?.abort?.()
          appShowController = null
        }
        break
      case "appHide":
        if (appHideController?.abort) {
          appHideController?.abort?.()
          appHideController = null
        }
        break
      default:
        return events.removeListener(key, fn)
    }
  }

  function onDispose() {
    events.dispose()
  }

  return {
    send,
    registerAppEvent,
    unregisterAppEvent,
    onDispose,
  }
}
